document.addEventListener('DOMContentLoaded', () => {
  let drawerDropdownButton = document.querySelector('#menu-drawer > div > div > nav > ul > li:nth-child(1) > div > div.dropdown-title');
  let drawerDropdownButtonIcon = drawerDropdownButton.querySelector('svg');
  let drawerDropdownContent = document.querySelector('.drawer-dropdown-content');

  let dropdownButton = document.querySelector('#shopify-section-sections--16164543627379__header > sticky-header > header > nav > ul > li:nth-child(1) > div > div.dropdown-title')
  let dropdownButtonIcon = dropdownButton.querySelector('svg')
  let dropdownContent = document.querySelector('#shopify-section-sections--16164543627379__header > sticky-header > header > nav > ul > li:nth-child(1) > div > div.dropdown-content')

  drawerDropdownButton.addEventListener("click",(e)=>{
    e.preventDefault()
    drawerDropdownContent.classList.toggle("show-drawer-dropdown")
    drawerDropdownButtonIcon.classList.toggle("rotate-icon")
  })
  dropdownButton.addEventListener("click",(e)=>{
    e.preventDefault()
    dropdownContent.classList.toggle("show-dropdown-content")
    dropdownButtonIcon.classList.toggle("rotate-icon")
  })
});
